import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-faq-card',
  templateUrl: './faq-card.component.html',
  styleUrls: ['./faq-card.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class FaqCardComponent implements OnInit {

  @Input() faqData: any = null;

  constructor() { }

  ngOnInit(): void {
  }

}
